import React, { useState } from 'react';
// import useState from 'react';

import { Link, useLocation } from 'react-router-dom';

export const Header = () => {

    // check current url and add action class to nav link
    const location = useLocation();
    const active = location.pathname;

    const [mobmenu, setMobmenu] = useState(false);

    

    return (
        <>
        <header className="tmp-header-area-start header-one header--sticky header--transparent" >
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="header-content">
                            <div className="logo">
                                <Link to="/">
                                    <img className="logo-dark" fetchPriority='high' width={250} height={57} src="assets/images/logo.png" width={250} alt="Reeni - Personal Portfolio HTML Template for developers and freelancers" />
                                    <img className="logo-white" fetchPriority='high' width={250} height={57} src="assets/images/logo.png" width={250} alt="Reeni - Personal Portfolio HTML Template for developers and freelancers" />
                                </Link>
                            </div>
                            <nav className="tmp-mainmenu-nav d-none d-xl-block">
                                <ul className="tmp-mainmenu">
                                    <li className={active === "/" ? "current" : ""}>
                                        <Link to="/">Početna</Link>
                                    </li>
                                    <li className={active === "/o-nama" ? "current" : ""}>
                                        <Link to="/o-nama">O Nama</Link>
                                    </li>
                                    <li className={active === "/servisi" ? "current" : ""}>
                                        <Link to="/servisi">Servisi</Link>
                                    </li>
                                    <li className={active === "/kontakt" ? "current" : ""}>
                                        <Link to="/kontakt">Kontakt</Link>
                                    </li>
                                </ul>

                            </nav>
                            <div className="tmp-header-right">
                                {/* <div className="social-share-wrapper d-none d-md-block">
                                    <div className="social-link">
                                        <a href="#"><i className="fa-brands fa-instagram"></i></a>
                                        <a href="#"><i className="fa-brands fa-linkedin-in"></i></a>
                                        <a href="#"><i className="fa-brands fa-twitter"></i></a>
                                        <a href="https://www.facebook.com/" target="_blank"><i className="fa-brands fa-facebook-f"></i></a>
                                    </div>
                                </div> */}
                                <div className="actions-area">
                                    {/* <div className="tmp-side-collups-area d-none d-xl-block">
                                        <button className="tmp-menu-bars tmp_button_active"><i className="fa-regular fa-bars-staggered"></i></button>
                                    </div> */}
                                    <div className="tmp-side-collups-area d-block d-xl-none">
                                        <button onClick={() => setMobmenu(!mobmenu)} className="tmp-menu-bars humberger_menu_active" aria-label='open mobile navigation'><i className="fa-regular fa-bars-staggered"></i></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </header>

       

        <div className="d-block d-xl-none">
            <div className={`tmp-popup-mobile-menu ${mobmenu ? "active" : ""}`}>
                <div className="inner">
                    <div className="header-top">
                        <div className="logo">
                            <Link to="/" className="logo-area">
                                <img className="logo-dark" width={250} height={57} loading='lazy' src="assets/images/logo.png" alt="Izrada Web Sajta Cena" />
                                <img className="logo-white" width={250} height={57} loading='lazy' src="assets/images/logo.png" alt="Izrada Web Sajta Cena" />
                            </Link>

                        </div>
                        <div className="close-menu">
                            <button onClick={() => setMobmenu(!mobmenu)} className="close-button tmp-round-action-btn" aria-label='close mobile navigation'>
                                <i className="fa-sharp fa-light fa-xmark"></i>
                            </button>
                        </div>
                    </div>
                    <ul className="tmp-mainmenu">
                        <li className={active === "/" ? "current" : ""}>
                            <Link to="/">Početna</Link>
                        </li>
                        <li className={active === "/o-nama" ? "current" : ""}>
                            <Link to="/o-nama">O Nama</Link>
                        </li>
                        <li className={active === "/servisi" ? "current" : ""}>
                            <Link to="/servisi">Servisi</Link>
                        </li>
                        <li className={active === "/kontakt" ? "current" : ""}>
                            <Link to="/kontakt">Kontakt</Link>
                        </li> 
                    </ul>


                    {/* <div className="social-wrapper mt--40">
                        <span className="subtitle">find with me</span>
                        <div className="social-link">
                            <a href="#"><i className="fa-brands fa-instagram"></i></a>
                            <a href="#"><i className="fa-brands fa-linkedin-in"></i></a>
                            <a href="#"><i className="fa-brands fa-twitter"></i></a>
                            <a href="#"><i className="fa-brands fa-facebook-f"></i></a>
                        </div>
                    </div> */}



                </div>
            </div>
        </div>
        </>
    );
};